// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".passenger-cargo-type[data-v-0531ac5c]  .el-form-item__content {\n  width: 6em;\n}", ""]);
// Exports
module.exports = exports;
